import { IonRow, IonCol, IonImg } from '@ionic/react';
import React, { useEffect, useState } from 'react';
import CompetitionsMenu from '../../components/ExchCompetitionsMenu/ExchCompetitionsMenu';
import './ExchBinaryView.scss';
import { clearExchcngeBets, fetchOpenBets, setExchEvent } from '../../store';
import { connect } from 'react-redux';
import ExchBinaryEventsTable from '../../components/ExchBinaryEventsTable/ExchBinaryEventsTable';
import ExchangeSportsListNav from '../../components/ExchSportsListNav/ExchangeSportsListNav';
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  useMediaQuery,
  useTheme,
} from '@material-ui/core';
import { useHistory } from 'react-router-dom';

import ExchBetslip from '../../components/ExchBetslip/ExchBetslip';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { BsData, PlaceBetRequest } from '../../models/BsData';
import { RootState } from '../../models/RootState';
import { UserBet } from '../../models/UserBet';
import { SelectedObj } from '../../models/ExchangeSportsState';
import moment from 'moment';
import ExchOpenBets from '../../components/ExchOpenBets/ExchOpenBets';
import HomeView from '../../constants/HomeView';
import { CONFIG_PERMISSIONS } from '../../constants/ConfigPermission';

type StoreProps = {
  allowedConfig: number;
  clearExchcngeBets: () => void;
  bets: PlaceBetRequest[];
  openBets: UserBet[];
  loggedIn: boolean;
  setExchEvent: (exchEvent: SelectedObj) => void;
  fetchOpenBets: (eventId: string) => void;
  langData:any;
};

const ExchBinaryView: React.FC<StoreProps> = (props) => {
  const {
    allowedConfig,
    clearExchcngeBets,
    bets,
    openBets,
    loggedIn,
    setExchEvent,
    fetchOpenBets,
    langData,
  } = props;
  const [openBetslip, setOpenBetslip] = useState<boolean>(true);
  const theme = useTheme();
  let history = useHistory();
  const isMobile = useMediaQuery(theme.breakpoints.down('xs'));
  const Images = HomeView.EVENT_PAGE_IMAGES;

  useEffect(() => {
    console.log(63 & CONFIG_PERMISSIONS.binary);
    if ((allowedConfig & CONFIG_PERMISSIONS.binary) === 0)
      return history.push('/home');

    clearExchcngeBets();
  }, []);

  useEffect(() => {
    if (!openBetslip && bets.length > 0) {
      setOpenBetslip(true);
    }
  }, [bets]);

  useEffect(() => {
    const exchEventId = 'BINARY/' + moment().format('YYYY-MM-DD');
    if (loggedIn) {
      fetchOpenBets(exchEventId);
    }
    setExchEvent({
      id: exchEventId,
      name: 'Binary' + moment().format('YYYY-MM-DD'),
      slug: 'binary' + moment().format('YYYY-MM-DD'),
    });
  }, [loggedIn]);

  return (
    <div>
      <IonRow className="exch-binary-view">
        {!isMobile ? (
          <IonCol className="exch-binary-competitions-menu-section">
            <div className="sticky-col">
              <CompetitionsMenu />
            </div>
          </IonCol>
        ) : null}
        <IonCol className="exch-binary-table-section">
          <div className="banner-container">
            <img
              className="banner-image"
              src={Images['binary']?.image}
              key={'binary-image'}
              alt={'banner'}
              title={'Stocks'}
            />
          </div>
          {isMobile && loggedIn && openBets.length > 0 ? (
            <div className="mob-open-bets-section">
              <div className="bs-open-bets-header">
              {langData?.['open_bets']} ({openBets.length})
              </div>
              <div className="bs-open-bets-ctn">
                {openBets.length > 0 ? (
                  <ExchOpenBets />
                ) : (
                  <div className="no-data">{langData?.['no_open_bets_txt']}</div>
                )}
              </div>
            </div>
          ) : null}
          <ExchBinaryEventsTable />
        </IonCol>
        <IonCol className="exch-binary-betslip-section">
          <Accordion
            className="bs-accordion"
            expanded={openBetslip}
            onChange={(_, expanded) => setOpenBetslip(expanded)}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon className="expand-icon" />}
              aria-controls="panel1a-content"
              className="bs-header"
            >
              {langData?.['bet_slip']} ({bets.length})
            </AccordionSummary>
            <AccordionDetails className="bs-body">
              {bets.length > 0 ? <ExchBetslip /> : null}
            </AccordionDetails>
          </Accordion>
          {!isMobile && loggedIn ? (
            <Accordion
              className="bs-accordion open-bets-accordion"
              defaultExpanded={true}
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon className="expand-icon" />}
                aria-controls="panel1a-content"
                className="bs-header"
              >
               {langData?.['open_bets']}({openBets.length})
              </AccordionSummary>
              <AccordionDetails className="bs-body">
                {openBets.length > 0 ? <ExchOpenBets /> : null}
              </AccordionDetails>
            </Accordion>
          ) : null}
        </IonCol>
      </IonRow>
    </div>
  );
};

const mapStateToProps = (state: RootState, ownProps) => {
  return {
    bets: state.exchBetslip.bets,
    openBets: state.exchBetslip.openBets,
    loggedIn: state.auth.loggedIn,
    allowedConfig: state.common.allowedConfig,
    langData:state.common.langData
  };
};

const mapDispatchToProps = (dispatch: Function) => {
  return {
    clearExchcngeBets: () => dispatch(clearExchcngeBets()),
    setExchEvent: (exchEvent: SelectedObj) => dispatch(setExchEvent(exchEvent)),
    fetchOpenBets: (eventId: string) => dispatch(fetchOpenBets(eventId)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ExchBinaryView);
